import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import logo from "../../assets/images/logo/BCT_logo_light.png"
import { Link } from "react-router-dom";

// Images
import Gflage from "../../assets/images/flage/Flag_of_Guinea.png"
import Eflage from "../../assets/images/flage/us-flag.png"

// Icons
import { IoIosArrowDown } from "react-icons/io";
import { IoArrowForwardOutline } from "react-icons/io5";
import { FaUser } from "react-icons/fa";
import { BsShop } from "react-icons/bs";
import { LuUsers } from "react-icons/lu";
import { getEnvVar } from "../../config/env-config";

function Navbar() {
  const { t } = useTranslation();
  const [isActive, setIsActive] = useState(false);
  const [selectedOption, setSelectedOption] = useState('English'); // Default selected option
  const [logocountry, setlogocountry] = useState(Gflage); // Default selected option

  useEffect(() => {
    if (selectedOption === "Français") {
      setlogocountry(Gflage)
    } else {
      setlogocountry(Eflage)
    }
  }, [selectedOption])

  const handleOptionClick = (language, countryFlag) => {
    // setStoredValue(language === 'Français' ? 'guinea' : 'english');
    setSelectedOption(language); // Update the selected option
    setlogocountry(countryFlag); // Change the flag image
    i18next.changeLanguage(language === 'Français' ? 'fr' : 'en'); // Change the i18next language
    setIsActive(false); // Close the dropdown
    localStorage.setItem("handleSelectedLanguage", language === 'Français' ? 'guinea' : 'english');
  };

  // for translation
  useEffect(() => {
    const selectLanguage = (decryptedValue) => {
      setSelectedOption(decryptedValue === "english" ? 'English' : 'Français');
      i18next.changeLanguage(decryptedValue === "english" ? 'en' : 'fr', (err, t) => {
        if (err) return console.error("something went wrong loading", err);
      });
    };
    selectLanguage(localStorage.getItem("handleSelectedLanguage"));
  }, [localStorage.getItem("handleSelectedLanguage")]);

  // For scroll sticky header
  const [navSize, setnavSize] = useState("7rem");
  const [navColor, setnavColor] = useState("transparent");
  const listenScrollEvent = () => {
    window.scrollY > 10 ? setnavColor("#001227") : setnavColor("transparent");
    window.scrollY > 10 ? setnavSize("5rem") : setnavSize("7rem");
  };
  useEffect(() => {
    window.addEventListener("scroll", listenScrollEvent);
    return () => {
      window.removeEventListener("scroll", listenScrollEvent);
    };
  }, []);

  // const [activeMenus, setActiveMenus] = useState([]);
  const [headerBackground, setHeaderBackground] = useState('transparent');

  useEffect(() => {
    const handleScroll = () => {
      const position = window.scrollY;
      if (position > 0) {
        setHeaderBackground('#001227'); // Change background color when scrolled
      } else {
        setHeaderBackground('transparent'); // Set background color to transparent when not scrolled
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (

    <header className={'navbar-custom'} id={'navbar'}>
      <nav className={'fixed top-0 left-0 w-full z-50  '} style={{ backgroundColor: headerBackground }}>

        <div className={'flex justify-between items-center h-24 w-full mx-auto px-16 2xl-max:px-4 text-white '} style={{
          backgroundColor: navColor,
          height: navSize,
          transition: "all 1s"
        }}>
          {/* Main Logo */}
          <Link to='/' className="">
            {/* Changed href to to */}
            <img className={'w-36'} src={logo} alt={'logo'} />
          </Link>
          <div className={'hidden justify-between items-center w-full lg:flex lg:w-auto'} id={'mobile-menu-2'}>
            {/* Navbar Menu */}
            <div className={` items-center `} id='menu-collapse'>
              <ul className={'navbar-nav lg:h-auto h-[290px] lg:overflow-visible overflow-y-scroll'} id={'navbar-navlist'}>
                <li>
                  <div className='dropdown'>
                    <Link to={'#home'} className={'nav-item dropdown-toggle'} id={'navbarDropdownOneButton'} data-dropdown-toggle={'navbarDropdownOne'} aria-current={'page'}>
                      {t('main.Navbarmenu.Solutions')}  <IoIosArrowDown className={'text-[17px] ml-2'} />
                    </Link>
                    <ul id={'navbarDropdownOne'} className={'dropdown-menu left-3 rounded-sm'}>
                      <li className={'dropdown'}>
                        <Link to={'/'} className={'dropdown-item flex items-center justify-between'}>
                          {t('main.Navbarmenu.Solution_menu.Customersa2c')}  <IoArrowForwardOutline className={'text-[14px]'} />
                        </Link>
                        <ul id={'navbarDropdownOne'} className={'dropdown-menu !right-[-220px] !top-[12px] rounded-sm'}>
                          <li><Link to={'/'} className={'flex items-center justify-between dropdown-item'}>{t('main.Navbarmenu.Solution_menu.Customers_a2c.Collect_Payment')}</Link></li>
                          <li><Link to={'/'} className={'flex items-center justify-between dropdown-item'}>{t('main.Navbarmenu.Solution_menu.Customers_a2c.Bill_Payment')}</Link></li>
                          <li><Link to={'/'} className={'flex items-center justify-between dropdown-item'}>{t('main.Navbarmenu.Solution_menu.Customers_a2c.Scan_to_pay')}</Link></li>
                          {/* <li><Link to={'/'} className={'flex items-center justify-between dropdown-item'}>{t('main.Navbarmenu.Solution_menu.Customers_a2c.Collect_Payment')}</Link></li> */}
                        </ul>
                      </li>
                      <li className={'dropdown'}>
                        <Link to={'/'} className={'dropdown-item flex items-center justify-between'}>
                          {t('main.Navbarmenu.Solution_menu.MerchantsB2B')}  <IoArrowForwardOutline className={'text-[14px]'} />
                        </Link>
                        <ul id={'navbarDropdownTwo'} className={'dropdown-menu !right-[-220px] !top-[12px] rounded-sm'}>
                          <li><Link to={'/'} className={'flex items-center justify-between dropdown-item'}>{t('main.Navbarmenu.Solution_menu.Merchants_B2B.Collect_Payment')}</Link></li>
                          <li><Link to={'/'} className={'flex items-center justify-between dropdown-item'}>{t('main.Navbarmenu.Solution_menu.Merchants_B2B.Disburse_Payment')}</Link></li>
                          <li><Link to={'/'} className={'flex items-center justify-between dropdown-item'}>{t('main.Navbarmenu.Solution_menu.Merchants_B2B.White_Label_Solutions')}</Link></li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </li>
                <li>
                  <div className={'dropdown'}>
                    <Link to={'/'} className={'nav-item dropdown-toggle'} id={'navbarDropdownThreeButton'} data-dropdown-toggle={'navbarDropdownThree'} aria-current={'page'}>
                      {t('main.Navbarmenu.Services')}  <IoIosArrowDown className={'text-[17px] ml-2'} />
                    </Link>
                    <ul id={'navbarDropdownThree'} className={'dropdown-menu left-3 !w-80 rounded-sm'}>
                      <li><Link to={'/'} className={'flex items-center justify-between dropdown-item'}>{t('main.Navbarmenu.Services_menu.CreateBankAccount')}</Link></li>
                      <li><Link to={'/'} className={'flex items-center justify-between dropdown-item'}>{t('main.Navbarmenu.Services_menu.Gateway_Payment_Integration')}</Link></li>
                      <li><Link to={'/developer-portal'} className={'flex items-center justify-between dropdown-item'}>{t('main.Navbarmenu.Services_menu.Developer_Portal')}</Link></li>
                    </ul>
                  </div>
                </li>
                <li>
                  <Link to={'/'} className={'nav-item'}> {t('main.Navbarmenu.Pricing')}</Link>
                </li>
                <li>
                  <Link to={'/'} className={'nav-item'}> {t('main.Navbarmenu.Entreprise')}</Link>
                </li>
                <li>
                  <div className={'dropdown'}>
                    <Link to={'/'} className={'nav-item dropdown-toggle'} id={'navbarDropdownFourButton'} data-dropdown-toggle={'navbarDropdownFour'} aria-current={'page'}>
                      {t('main.Navbarmenu.Insights')} <IoIosArrowDown className={'text-[17px] ml-2'} />
                    </Link>
                    <ul id={'navbarDropdownFour'} className={'dropdown-menu left-3 !w-32 rounded-sm'}>
                      <li><Link to={'/'} className={'flex items-center justify-between dropdown-item'}>{t('main.Navbarmenu.Insights_menu.Press')}</Link></li>
                      <li><Link to={'/'} className={'flex items-center justify-between dropdown-item'}>{t('main.Navbarmenu.Insights_menu.Inside')}</Link></li>
                    </ul>
                  </div>
                </li>
                <li>
                  <Link to={'/'} className={'nav-item'}>{t('main.Navbarmenu.Careers')}</Link>
                </li>
                <li>
                  <Link to={'/'} className={'nav-item'}>{t('main.Navbarmenu.Contact')}</Link>
                </li>
                {/* <li>
                  <Link to={'/faq'} className={'nav-item'}>{t('main.Navbarmenu.Faq')}</Link>
                </li> */}
                <li>
                  <div className={'dropdown'}>
                    <Link to={'/'} className={'nav-item dropdown-toggle'} id={'navbarDropdownFourButton'} data-dropdown-toggle={'navbarDropdownFour'} aria-current={'page'}>
                      {t('main.FAQ.FAQs')} <IoIosArrowDown className={'text-[17px] ml-2'} />
                    </Link>
                    <ul id={'navbarDropdownFour'} className={'dropdown-menu left-3 !w-35 rounded-sm'}>
                      <li><Link to={'/user_faqs'} className={'flex items-center justify-between dropdown-item'}>{t('main.FAQ.Users_FAQs')}</Link></li>
                      <li><Link to={'/whitelabels_faqs'} className={'flex items-center justify-between dropdown-item'}>{t('main.FAQ.WhiteLabels_FAQs')}</Link></li>
                    </ul>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <div className={'flex items-center'}>
            <ul className={'flex items-center'}>
              {/* Country Selector Start */}
              <li>
                <div className={'relative dropdown'}>
                  <ul
                    className={`nav-item dropdown-toggle`}
                    id={'navbarDropdownOneButton'}
                    data-dropdown-toggle={'navbarDropdownOne'}
                    aria-current={'page'}
                    default_option="true"
                    rounded-md="true"
                    cursor-pointer="true"
                  >
                    <li
                      className={`p-3  flex items-center text-white cursor-pointer ${isActive ? "active" : ""
                        }`}
                      onClick={() => setIsActive(!isActive)}
                    >
                      <img
                        className="w-5 h-5 rounded-full"
                        src={logocountry}
                        alt={'English'}
                      />
                      <p className="ml-2">{selectedOption}</p>
                      {/* <p className={'ml-2'}>English</p> */}
                      <IoIosArrowDown className={'text-[17px] ml-2'} />
                    </li>
                  </ul>
                  <ul
                    id="navbarDropdownOne"
                    className={`dropdown-menu cursor-pointer select_ul absolute top-11 left-3 !w-36 bg-white rounded-sm ${isActive ? "block" : "hidden"
                      }`}
                  >
                    <li
                      className="p-3 text-[#6b7280] flex items-center justify-between"
                      onClick={() => handleOptionClick("English", Eflage)} // Pass the correct flag
                    >
                      <div className="option flex items-center">
                        <img
                          className="w-5 h-5 rounded-full"
                          src={Eflage}
                          alt="English"
                        />
                        <p className="ml-2">{t('main.Navbarmenu.languade.English')}</p>
                      </div>
                    </li>

                    <li
                      className="p-2 text-[#6b7280] flex items-center justify-between"
                      onClick={() => handleOptionClick("Français", Gflage)} // Pass the correct flag
                    >
                      <div className="option flex items-center">
                        <img
                          className="w-5 h-5 rounded-full"
                          src={Gflage}
                          alt="Guinea"
                        />
                        <p className="ml-2">{t('main.Navbarmenu.languade.franch')}</p>
                      </div>
                    </li>
                  </ul>
                </div>
              </li>
              {/* Country Selector End */}
              <li>
                <div className={'dropdown'}>
                  <Link to={'/'} className={'nav-item dropdown-toggle p-3 flex items-center'} id={'navbarDropdownFourButton'} data-dropdown-toggle={'navbarDropdownFour'} aria-current={'page'}>
                    <FaUser className={'mr-2'} /> {t('main.Navbarmenu.login')} <IoIosArrowDown className={'text-[17px] ml-2'} />
                  </Link>
                  <ul id={'navbarDropdownThree'} className={'dropdown-menu left-0  !w-36 rounded-sm'}>
                    <li><Link to={(getEnvVar('REACT_APP_ADMIN_UI_BASE_URL') || '') + 'b2b-signin'} target="_blank" className={'flex items-center justify-start gap-3 dropdown-item'}><BsShop className="text-[18px]" /> Merchant</Link></li>
                    <li><Link to={(getEnvVar('REACT_APP_ADMIN_UI_BASE_URL') || '') + 'customerlogin'} target="_blank" className={'flex items-center justify-start gap-3 dropdown-item'}>< LuUsers className="text-[18px]" />Customer</Link></li>
                  </ul>
                </div>
              </li>
              {/* <li className="text-white text-[18px] elementor-animation-float mx-3">
              <Link
                className=" inline-flex border-[3px] rounded-sm items-center justify-center hover:before:bg-redborder-red-500 relative px-3 h-[50px] overflow-hidden border  border-whire bg-white/0 text-white  transition-all before:absolute before:bottom-0 before:left-0 before:top-0 before:z-0 before:h-full before:w-0 before:bg-gradient-to-r from-[#fe7b05] to-[#eabb76] before:transition-all before:duration-500 hover:text-white hover:before:left-0 hover:before:w-full"
              >
                <span className="flex items-center justify-center relative z-10">
                  Get in Touch <IoIosArrowForward className="ml-2" />
                </span>
              </Link>
            </li> */}
            </ul>
          </div>
        </div>
      </nav>
    </header>

  );
}

export default Navbar;
